import classNames from 'classnames';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';
import {
  MessageCircleQuestionIcon,
  MessageCircleQuestionIconHandle,
} from '@/Domain/components/icons/MessageCircleQuestionIcon';

type Props = {
  messageId: number;
  onClick: () => void;
};

export const WhyAISaidThatButton = ({ messageId, onClick }: Props) => {
  const { t } = useTranslation('inbox_v2');
  const iconRef = useRef<MessageCircleQuestionIconHandle>(null);

  return (
    <Button
      variant="ghost"
      size="xs"
      className={classNames('mt-px')}
      data-testid={`why-ai-said-that-button-${messageId}`}
      onClick={onClick}
      onMouseEnter={() => iconRef.current?.startAnimation()}
      onMouseLeave={() => iconRef.current?.stopAnimation()}
    >
      <MessageCircleQuestionIcon ref={iconRef} />
      <span>{t('why_ai_said_that')}</span>
    </Button>
  );
};
